<template>
    <div>
        <div class="form-group row">
            <label class="col-sm-2">{{ $t('managerForm.settingPage.pageTypeB.topText') }}</label>
            <div class="col-sm-10">
                <Editor
                    id="editor-header-rejection"
                    :model.sync="initRejectionForm.extension.text_above"
                    :configError.sync="confiRejectionFormB.extension.text_above"
                    :configInit="confiRejectionFormB.extension.text_above"
                    @blur="onHandleValid(initRejectionForm.extension.text_above, confiRejectionFormB.extension.text_above)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-2">{{ $t('managerForm.settingPage.pageTypeB.rejectionDetail') }}</label>
            <div class="col-sm-10">
                <Editor
                    id="editor-detail-rejection"
                    :model.sync="initRejectionForm.extension.no_win_content"
                    :configError.sync="confiRejectionFormB.extension.no_win_content"
                    :configInit="confiRejectionFormB.extension.no_win_content"
                    @blur="onHandleValid(initRejectionForm.extension.no_win_content, confiRejectionFormB.extension.no_win_content)"
                />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-2">{{ $t('managerForm.settingPage.pageTypeB.bottomText') }}</label>
            <div class="col-sm-10">
                <Editor
                    id="editor-footer-rejection"
                    :model.sync="initRejectionForm.extension.text_below"
                    :configError.sync="confiRejectionFormB.extension.text_below"
                    :configInit="confiRejectionFormB.extension.text_below"
                    @blur="onHandleValid(initRejectionForm.extension.text_below, confiRejectionFormB.extension.text_below)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Editor from '@/components/Editor/main.vue';

import { validateField } from '@/utils/validate_v2';
export default {
    name: 'SettingRejectionFormB',
    components: {
        Editor
    },
    props: {
        formRejectionInit: {
            type: Object,
            default: () => ({})
        },
        confiRejectionFormB: {
            type: Object,
            default: () => ({})
        },
        typeSettingScreen: {
            type: String,
            default: 'text'
        }
    },
    data() {
        return {
            initRejectionForm: {}
        };
    },
    methods: {
        onHandleValid(valueField, configField) {
            validateField(valueField, configField);
        },

        getDataFormRejection() {
            return JSON.parse(JSON.stringify(this.initRejectionForm));
        },
        resetDataFormRejection() {
            this.initRejectionForm = JSON.parse(JSON.stringify(this.formRejectionInit));
        }
    },

    watch: {
        formRejectionInit: {
            handler: function (newVal) {
                this.initRejectionForm = JSON.parse(JSON.stringify(newVal));
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
